export default __webpack_public_path__ + "static/media/home-vaccine-vector.32d89e8a.svg";